import { render } from "./BackgroundRibbon.vue?vue&type=template&id=c6dcb5ea&scoped=true&ts=true"
import script from "./BackgroundRibbon.vue?vue&type=script&lang=ts"
export * from "./BackgroundRibbon.vue?vue&type=script&lang=ts"

import "./BackgroundRibbon.vue?vue&type=style&index=0&id=c6dcb5ea&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6dcb5ea"]])

export default __exports__